import { BaseApi, type RequestHeaders, type RequestParams, type ListResponse } from '@bv/api/base';

export class WithList<Item extends Record<string, any> = object> extends BaseApi {
  /**
   * Creates an instance of the child class.
   * This constructor passes the endpoint to the parent class's constructor.
   * @param {string} endpoint - The API endpoint that will be passed up to the base class constructor.
   */
  public constructor(endpoint: string) {
    super(endpoint);
  }

  /**
   * Fetch all items
   * @param {Object} [config] - Optional configuration for the request.
   * @param {RequestParams} [config.params] - Additional query parameters to send with the request.
   * @param {RequestHeaders} [config.headers] - Custom HTTP headers to send with the request.
   * @returns {Promise<Item[]>}
   * @public
   */
  public async list({ params, headers }: { params?: RequestParams; headers?: RequestHeaders } = {}): Promise<Item[]> {
    return this.request<Item, ListResponse<Item>>({ method: 'get', params, headers }).then((response) => {
      return response.data;
    });
  }
}
